import { render, staticRenderFns } from "./EditStockItemAlternative.vue?vue&type=template&id=6225a23c"
import script from "./EditStockItemAlternative.vue?vue&type=script&lang=js"
export * from "./EditStockItemAlternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditStockItemAlternative.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6225a23c')) {
      api.createRecord('6225a23c', component.options)
    } else {
      api.reload('6225a23c', component.options)
    }
    module.hot.accept("./EditStockItemAlternative.vue?vue&type=template&id=6225a23c", function () {
      api.rerender('6225a23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditStockItemAlternative.vue"
export default component.exports